import { Group } from '@components/layout';
import { ServerTag } from '@components/server';
import { Tag } from '@components/tag';
import { type SxProps } from '@mui/material';

export const ResourceTag = ({
  name,
  source,
  sx,
  onDelete,
}: {
  name: string;
  source: 'organization' | 'user' | 'workspace';
  sx?: SxProps;
  onDelete?: () => void;
}) => {
  return (
    <Tag
      label={
        <Group alignItems="center" gap={2} sx={sx}>
          <span>{name}</span>
          <ServerTag
            label={source}
            color={source}
            variant="caption2"
            sx={{ textTransform: 'capitalize' }}
          />
        </Group>
      }
      onDelete={onDelete}
    />
  );
};
